import BackToTop from '../../BackToTop/BackToTop'
import Heading from '../../Heading/Heading'
import Text from '../../Text/Text'

import './GlossaryFooter.scss'

const GlossaryFooter = ({ footerHeading, footerText }) => (
  <section className="c-glossary-footer">
    <div className="c-glossary-footer__glossary-info-container">
      <Heading>{footerHeading}</Heading>
      <Text>{footerText}</Text>
    </div>
    <BackToTop />
  </section>
)

export default GlossaryFooter
